import { ElementTypes } from '../element-types';

export class SendQuote {
  private static readonly prefix: string = 'send-quote';
  static readonly Label: string = `${SendQuote.prefix}-${ElementTypes.Label}`;
  static readonly Email: string = `${SendQuote.prefix}-${ElementTypes.Input}-email`;
  static readonly Privacy: string = `${SendQuote.prefix}-${ElementTypes.Checkbox}-privacy`;
  static readonly SendButton: string = `${SendQuote.prefix}-${ElementTypes.Button}-send`;
  static readonly SendAnotherButton: string = `${SendQuote.prefix}-${ElementTypes.Button}-sendanother`;
}
